import { WMAP_PREFIX } from '~/modules/payment/constants';

export const DONATION_SEGMENT = 'donation';
export const DELIVERY_SEGMENT = 'delivery';
export const WARRANTY_SEGMENT = 'warranty';
export const DELIVERY_DESCRIPTION = 'delivery';
export const DONATION_DELIVERY_PRODUCT_TYPE = '2';
export const STANDARD_PRODUCT_TYPE = '1';
export const FALLBACK_STORE_PHONE = '877-384-2903';
export const PURCHASE_CHANNEL_STORE = 'store';
export const ERROR_PAGE_CODES = ['4001', '4002'];
export const BUTTON_TEXT = 'Go To Mattressfirm.com';
export const BUTTON_LINK = 'https://www.mattressfirm.com';
export const INPUT_ID_OTHER_AMOUNT = 'other-amount-radio';
export const INPUT_ID_OUTSTANDING_AMOUNT = 'outstanding-blnc-radio';
export const INPUT_ID_SAME_AS_DELIVERY = 'same-as-delivery-radio';
export const LABEL_ID_SAME_AS_DELIVERY = `${WMAP_PREFIX}-same-as-delivery-label`;
export const LABEL_ID_DIFFERENT_BILLING_ADDRESS = `${WMAP_PREFIX}-different-billing-address-label`;
export const INPUT_ID_DIFFERENT_BILLING_ADDRESS =
  'different-billing-address-radio';
export const LABEL_ID_OTHER_AMOUNT = `${WMAP_PREFIX}-other-amt-radio-btn`;
export const LABEL_ID_OUTSTANDING_AMOUNT = `${WMAP_PREFIX}-outstanding-balance-radio-btn`;
export const paymentNote =
  '*Your order must be paid in full to schedule delivery.';

export const IS_FORTER_ENABLED = 'isForterEnable';
export const NATIONAL_SALES_CHAT_STORE_ID = ['095099'];
export const EVENT_WMAP_ORDER_SUMMARY_CALL_CLICK =
  'wmap order summary call click';
export const EVENT_WMAP_ORDER_CALL_CLICK = 'wmap order review call click';

export const EVENT_WMAP_ORDER_SUMMARY_CHAT_CLICK =
  'click from wmap order summary';

export const EVENT_WMAP_ORDER_CHAT_CLICK = 'click from wmap modify order';
export const DONATION_IMG = 'Products/wmap-donation.png';
export const DELIVERY_IMG = 'Products/wmap-delivery.png';
export const FALLBACK_IMG = 'Products/no-image-available.png';
export const PLAN_ID = {
  offer24: '124',
};
export const BREAKPOINTS = {
  extraLargeDesktop: 1340,
  largeDesktop: 1200,
  mediumDesktop: 1440,
  desktop: 1025,
  tablet: 768,
  mobile: 768,
  xs: 375,
  smallMobile: 320,
};
export const affirmMerchantName = 'Mattress Firm - Online Pay';
export const IS_MS_CHAT_ENABLED = 'isMSChatEnabled';
export const IS_FORTER_ENABLED_FOR_ADYEN_CC = 'isForterEnabledForAdyenCC';
